import React from 'react'
import { FaChevronDown } from 'react-icons/fa'
import Footer from '../../components/footer/Footer'

const Faqs = () => {
  return (
    <div className='faqs'>
        <div className="content">
            <div className="heading">
                <h2>
                    Frequently asked Questions
                </h2>
                <p>
                    <i>
                        Sample text. Click to select the text box. Click again or double click to start editing the text. 
                    </i>
                </p>
            </div>

            <div className="container">
                <div className="faq">
                    <div className="open-faq">
                        <p>
                            Do you provide support?
                        </p>
                        <div className="open">
                            <FaChevronDown />
                        </div>
                    </div>
                    <div className="faq-content">
                    Answer. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur id suscipit ex. Suspendisse rhoncus laoreet purus quis elementum. Phasellus sed efficitur dolor, et ultricies sapien. Quisque fringilla sit amet dolor commodo efficitur. Aliquam et sem odio. In ullamcorper nisi nunc, et molestie ipsum iaculis sit amet.
                    </div>
                </div>
                <div className="faq">
                    <div className="open-faq">
                        <p>
                            Do you provide support?
                        </p>
                        <div className="open">
                            <FaChevronDown />
                        </div>
                    </div>
                    <div className="faq-content">
                    Answer. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur id suscipit ex. Suspendisse rhoncus laoreet purus quis elementum. Phasellus sed efficitur dolor, et ultricies sapien. Quisque fringilla sit amet dolor commodo efficitur. Aliquam et sem odio. In ullamcorper nisi nunc, et molestie ipsum iaculis sit amet.
                    </div>
                </div>
                <div className="faq">
                    <div className="open-faq">
                        <p>
                            Do you provide support?
                        </p>
                        <div className="open">
                            <FaChevronDown />
                        </div>
                    </div>
                    <div className="faq-content">
                    Answer. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur id suscipit ex. Suspendisse rhoncus laoreet purus quis elementum. Phasellus sed efficitur dolor, et ultricies sapien. Quisque fringilla sit amet dolor commodo efficitur. Aliquam et sem odio. In ullamcorper nisi nunc, et molestie ipsum iaculis sit amet.
                    </div>
                </div>
                <div className="faq">
                    <div className="open-faq">
                        <p>
                            Do you provide support?
                        </p>
                        <div className="open">
                            <FaChevronDown />
                        </div>
                    </div>
                    <div className="faq-content">
                    Answer. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur id suscipit ex. Suspendisse rhoncus laoreet purus quis elementum. Phasellus sed efficitur dolor, et ultricies sapien. Quisque fringilla sit amet dolor commodo efficitur. Aliquam et sem odio. In ullamcorper nisi nunc, et molestie ipsum iaculis sit amet.
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
  )
}

export default Faqs